import { useState, useEffect, useCallback } from "react";
import { Star, Trash2, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api } from "./AdminShared";

export default function AdminReviewsTab({ token }) {
  const [reviews, setReviews] = useState([]);
  const load = useCallback(() => { api(token).get("/reviews/all").then((r) => setReviews(r.data)).catch(() => {}); }, [token]);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="space-y-3">
      <p className="text-zinc-500 text-sm mb-4">{reviews.length} review{reviews.length !== 1 ? "s" : ""}</p>
      {reviews.map((r) => (
        <div key={r.id} className="border border-white/10 rounded-xl p-4 bg-gg-surface">
          <div className="flex justify-between">
            <div>
              <p className="text-white font-semibold text-sm">{r.name}</p>
              <div className="flex gap-0.5 mt-1">{[1,2,3,4,5].map((s) => <Star key={s} size={12} className={s <= r.rating ? "fill-gg-red text-gg-red" : "text-zinc-700"} />)}</div>
            </div>
            <div className="flex gap-1">
              {!r.approved && <Button size="sm" variant="ghost" onClick={async () => { await api(token).put(`/reviews/${r.id}/approve`); load(); toast.success("Approved"); }} className="text-green-500"><Check size={14} /></Button>}
              <Button size="sm" variant="ghost" onClick={async () => { await api(token).delete(`/reviews/${r.id}`); load(); }} className="text-zinc-500 hover:text-red-500"><Trash2 size={14} /></Button>
            </div>
          </div>
          <p className="text-zinc-300 text-sm mt-2 italic">"{r.text}"</p>
          <span className={`text-xs px-2 py-0.5 mt-2 inline-block rounded-full ${r.approved ? "bg-green-900/30 text-green-400" : "bg-yellow-900/30 text-yellow-400"}`}>{r.approved ? "Live" : "Pending"}</span>
        </div>
      ))}
    </div>
  );
}
